import React from "react";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Button from "../button/Button";
import close from "../../assets/kangaroo/closebutton.svg";
import "./FormClose.css";
import image from "../../assets/kangaroo/thankyouimg.png";

const FormClose = ({ modal, toggle, closeBtn, description, heading }) => {
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      style={{ maxWidth: "600px", width: "90%" }}
      contentClassName="thankyou-modal"
    >
      <ModalHeader></ModalHeader>

      <ModalBody>
        <Container
          fluid
          className="w-75 d-flex flex-column justify-content-center m-0  "
          style={{ height: "41.2rem" }}
        >
          {/* This wrapper will center the two rows as a single block */}
          <div className="d-flex flex-column  align-items-start ">
            <Row className="text-left mb-3 ms-4 ">
              <Col>
                <div>
                  <h1 className="thankyou-font">Thank You</h1>
                  <h1 className="thankyou-desc">{heading}</h1>
                  <p className="thankyou-trail">{description}</p>
                </div>
                <img
                  src={image}
                  fluid
                  className="position-absolute"
                  style={{ top: 0, right: 0, maxWidth: "81.3%" }}
                  alt=""
                />
              </Col>
            </Row>

            <Row className="mb-3 ms-4">
              <Col className="d-flex justify-content-center">
                <button
                  type="button"
                  className="buttonImg d-flex  align-items-center "
                  style={{ cursor: "pointer" }}
                  onClick={toggle}
                >
                  <p className="button-font-formclose">CLOSE</p>
                </button>
              </Col>
            </Row>
          </div>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default FormClose;
